import './i18n'

import React from 'react'
import { useTranslation } from 'react-i18next'

export const useI18n = () => {
  const { t } = useTranslation()
  return (key: string, params?: Record<string, any>) => {
    const result = t(key, params || {})
    return typeof result === 'string' ? result : String(result)
  }
}

export const useScopedI18n = (scope: string) => {
  const { t } = useTranslation()
  return (key: string, params?: Record<string, any>) => {
    const result = t(`${scope}.${key}`, params || {})
    return typeof result === 'string' ? result : String(result)
  }
}

export const I18nProviderClient = ({ children }: { children: React.ReactNode }) => {
  return React.createElement(React.Fragment, null, children)
}

export const useCurrentLocale = () => {
  const { i18n } = useTranslation()
  return i18n.language
}
